// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Printer = function Printer(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14.3 5.5H12v-4H4v4H1.7a.71.71 0 00-.7.7v4.6a.71.71 0 00.7.7H4v3h8v-3h2.3a.71.71 0 00.7-.7V6.2a.71.71 0 00-.7-.7zm-3.3 8H5v-4h6zm0-8H5v-3h6zm2.5 2A.5.5 0 1114 7a.5.5 0 01-.5.5z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M6 10h4v1H6zM6 12h4v1H6z"
    }))
  );
};

export default Printer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Printer.js
// module id = 1039
// module chunks = 0